module.exports = "https://staticsandbox.coteibem.com.br/assets/circle-search-love.2bf836dab9580fa0d6132c5811b35499.svg";